module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 748.29 950.43"
    }
  }, [_c('g', {
    staticClass: "primary-svg",
    attrs: {
      "id": "Icon"
    }
  }, [_c('path', {
    attrs: {
      "d": "M764,332l-70.55-72.7L602.9,347.21V58.31H501.59v288.9L411,259.3,340.47,332,552.24,537.55Zm160.72,26.79-45.2,43.87v489a70.34,70.34,0,0,1-70.26,70.27H295.21A70.34,70.34,0,0,1,225,891.63v-489l-45.2-43.86a117.15,117.15,0,0,0-1.65,18.76V891.63a117.24,117.24,0,0,0,117.11,117.11H809.28A117.24,117.24,0,0,0,926.39,891.63V377.56A117.38,117.38,0,0,0,924.74,358.79ZM831.31,688.94V646.09H680V851.46h53.5v-79.1h84.57V730.94H733.51v-42ZM468,646.09V851.46h88.3c62.42,0,100.68-36.24,100.68-103.55,0-63.57-37.68-101.82-100.68-101.82ZM603.45,747.62c0,41.14-16.11,57-56.67,57.82H521.47V692.11h25.31C583.31,692.11,603.45,710.23,603.45,747.62ZM326.68,783h44c45.16,0,74.22-19.84,74.22-70.76,0-48.61-36-66.15-74.22-66.15H273.18V851.46h53.5Zm0-94.06h36c16.39,0,28.76,7.77,28.76,27,0,18.7-12.08,25.6-28.76,25.6h-36Z",
      "transform": "translate(-178.1 -58.31)"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-faa3b460","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/ExportPdfSvg.vue
// module id = 3405
// module chunks = 0